'use strict'

export function processYandexExecutorSelectionError (target, response) {
  const accountAssignedEmployeesOptions = response.accountAssignedEmployee || []
  for (const option of accountAssignedEmployeesOptions) {
    option.key = option.id
  }

  const accountAssignedEmployeeDefault = accountAssignedEmployeesOptions.length === 1 ? accountAssignedEmployeesOptions[0] : null

  const message1 = 'Пользователь Учетной записи Яндекс "' + response.accountLogin + //
        '", назначенной на Заявку №' + response.requestNumber + //
        ',  должен быть включен в бригаду "' + response.brigadeName + '".' //

  const message2 = 'Выберите пользователя из текущего состава бригады "' + response.brigadeName + '", которому будет передана учетная запись:' //

  return new Promise((resolve, reject) => {
    target.$d_ask({
      callback: (data) => {
        const assignedEmployeeId = data.accountAssignedEmployee // id

        const accountAssignmentConfig = {
          assignedEmployeeId: assignedEmployeeId,
          accountId: response.accountId,
          brigadeId: response.brigadeId
        }
        resolve(accountAssignmentConfig)
      },
      warning: [message1, message2],
      propsConfig: {
        accountAssignedEmployee: {
          type: 'listvalue',
          label: 'Пользователь учетной записи Яндекс',
          listvalues: accountAssignedEmployeesOptions,
          value: accountAssignedEmployeeDefault != null ? accountAssignedEmployeeDefault.id : null,
          required: true
        }
      }
    })
  })
}
